import { transparentize } from 'polished';
import { css } from 'styled-components';
import theme from "../themes/light/theme";
export var svgToDataURL = function svgToDataURL(svgStr) {
  var encoded = encodeURIComponent(svgStr).replace(/'/g, '%27').replace(/"/g, '%22');
  var header = 'data:image/svg+xml,';
  var dataUrl = header + encoded;
  return dataUrl;
};
export var visuallyHidden = css(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);border:0;"]);
export var focusRing = css(["box-shadow:0 0 0 1px ", ",0 0px 0px 4px ", ";outline:none;&::-moz-focus-inner{border:0;}"], theme.colors.button.primary.background.base, transparentize(0.7, theme.colors.button.primary.background.base));
export var pill = css(["min-width:", ";min-height:", ";padding:", " ", ";border-radius:", ";"], theme.space[600], theme.space[600], theme.space[300], theme.space[350], theme.radii.pill);
export var disabled = css(["opacity:0.4;pointer-events:none;"]);